import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromRoomSelectors from '../../../../stores/rooms/rooms.selector';
import * as fromMobileFolioReducer from './mobilefolio.reducer';
import * as fromMobileFolioState from './mobilefolio.state';
import { MobileFolioState } from './mobilefolio.state';

export const selectMobileFolioState = createFeatureSelector<MobileFolioState>(
  fromMobileFolioState.inRoomMobileFolioFeatureKey
);

export const selectMobileFolioEntities = createSelector(
  selectMobileFolioState,
  fromMobileFolioReducer.selectMobileFolioEntities
);

export const selectCurrentMobileFolio = createSelector(
  selectMobileFolioEntities,
  fromRoomSelectors.selectCurrentRoom,
  (entities, room) => (!!room && room.PmsReferenceCode ? entities[room.PmsReferenceCode] : undefined)
);
